import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      q: 'What is a CSSBuy Spreadsheet?',
      a: 'A CSSBuy Spreadsheet is a curated collection of product links organized by category, making it easy to browse and discover items available through CSSBuy. Think of it as a master catalog that compiles the best finds across shoes, clothing, accessories, and more — all in one organized document.',
    },
    {
      q: 'How often is the CSSBuy Spreadsheet updated?',
      a: 'Our CSSBuy spreadsheet collection is updated daily with new finds, trending items, and seasonal picks. We continuously monitor the latest drops and community favorites to ensure you always have access to the freshest listings. Check back regularly or bookmark our homepage for the most current version.',
    },
    {
      q: 'How do I use the CSSBuy Spreadsheet to find products?',
      a: 'Simply browse through the categories on our website — from Shoes to Accessories — and click on any category to be redirected to the full spreadsheet on kaspreadsheet.com. Each spreadsheet is organized with product names, prices, QC photos, sizing info, and direct purchase links for easy navigation.',
    },
    {
      q: 'What categories are available in the CSSBuy Spreadsheet?',
      a: 'We cover 14 comprehensive categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff. Each category has its own dedicated spreadsheet with hundreds of verified listings.',
    },
    {
      q: 'Is the CSSBuy Spreadsheet free to use?',
      a: 'Yes! All CSSBuy spreadsheet categories are completely free to browse. We believe in open access to quality finds — no paywalls, no hidden fees. Just click, browse, and discover your next favorite item at your own pace.',
    },
    {
      q: 'How do I find the best CSSBuy Spreadsheet picks?',
      a: 'For the best experience, start with our Buying Guide articles which detail how to evaluate QC photos, understand sizing, and identify top-tier items. Then explore our featured finds section for handpicked recommendations, or dive directly into any category spreadsheet on kaspreadsheet.com.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full uppercase tracking-wider">
              FAQ
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              Everything you need to know about using our CSSBuy spreadsheet collection
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl border border-background-200/60 bg-background-100 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer"
                >
                  <h4 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </h4>
                  <i
                    className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform duration-200 shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}